import React from 'react';
import { Col, Row, Skeleton } from 'antd';
import { useParams } from 'react-router-dom';

import { Header } from './Header';
import { Content } from './Content';
import { useSearchParams } from '@/hooks/v1';
import type { BaseContext } from '@/types';
import type { ReportParams } from './types';
import { RosaReportProvider } from './context';
import { useGetRosaData } from './hooks/useGetRosaData';
import { useApplicationContext } from '@/context/v1/Application/context';

export function Rosa() {
	const { file_id } = useParams<ReportParams>();
	const { organization, company } = useApplicationContext();
	const { organization_id = organization?.id, company_id = company?.id } = useSearchParams<BaseContext>();

	const { data: rosaData, isLoading, isError } = useGetRosaData({ organization_id, company_id, id: file_id });

	if (isLoading) {
		return <Skeleton active />;
	}

	if (isError) {
		return <Skeleton active />;
	}

	return (
		<RosaReportProvider reportData={rosaData}>
			<Row gutter={[0, 30]}>
				<Col span={24}>
					<Header>ROSA</Header>
				</Col>
				<Col span={24}>
					<Content />
				</Col>
			</Row>
		</RosaReportProvider>
	);
}
